// @flow

import React from 'react';

import { Fab, Tooltip, Menu, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import { getSnack } from '../../utils/snackbar';
import { calls as api } from '../../services/api/ava';
import Phone from '../../../assets/icons/phone.png';

const useStyles = makeStyles({
  root: { marginLeft: 30, marginRight: 30 },
  fab: { width: 44, height: 44, boxShadow: 'none', color: 'white' },
});

type Props = {
  user: Object,
  status: Object,
  theme: Object,
};

export default function PhoneMenuItem(props: Props) {
  const classes = useStyles();
  const { status } = props;
  const { twilioCalls: twilio } = status || {};
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const calls: Array<any> = Array.from(Object.keys(twilio || {})).map(key => ({
    sid: key,
    ...twilio[key],
  }));

  const endCall = async sid => {
    setAnchorEl(null);
    try {
      const { user } = props;
      await api.terminateCall({ user, sid });
      getSnack(props)('Call ended.');
    } catch (err) {
      getSnack(props)(err.message, { variant: 'error' });
    }
  };

  const { theme } = props;

  return (
    <div className={classes.root}>
      {calls
        .filter(call => call.status === 'in-progress')
        .map((call, i) => (
          // eslint-disable-next-line
          <div key={`${call.to}-${i}`}>
            <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
              <>
                <Tooltip title={call.to}>
                  <Fab
                    className={classes.fab}
                    onClick={handleClick}
                    style={{
                      backgroundColor: theme.palette.ava.green,
                    }}
                  >
                    <img src={Phone} alt="phone" height="20" className={classes.fabImg} />
                  </Fab>
                </Tooltip>
                <Menu id="simple-menu" anchorEl={anchorEl} open={Boolean(anchorEl)}>
                  <MenuItem onClick={() => endCall(call.sid)}>End call</MenuItem>
                </Menu>
              </>
            </ClickAwayListener>
          </div>
        ))}
    </div>
  );
}
